An optional hirer-provided free-text job reference.

This field has a maximum length of 50 characters.
